const colorPalette = {
  primary: "#FFF6E5", // light beige
  secondary: "#F5A962", // peachy orange
  tertiary: "#8F6B4A", // brown
  quaternary: "#4B4E6D", // blue-gray
  quinary: "#D5D5D5", // light gray
};

export default colorPalette;
